export default __webpack_public_path__ + "static/media/wallet-card-theme3.4d5fd2ec.svg";